<template>
  <div id="ChinaMapTerimal">
    <echartsChina ref="echartChina" style="height:100%" :data="ehartsChinaObjec"></echartsChina>
  </div>
</template>

<script>
import { populationData } from './js/chinaPopulationData'
import echartsChina from '@/components/echarts/echartsChina'
import common from '@/mixins/common.js'

export default {
  name: 'ChinaMapTerimal',
  mixins: [common],
  components: {
    echartsChina
  },
  props: {},
  data () {
    return {
      terimalLists: {}, // 终端
      ehartsChinaObjec: {
        terminalMapList: []
      }
    }
  },
  computed: {

  },
  created () {

  },
  mounted () {
    this.ehartsChinaObjec.terminalMapList = populationData.map(item => {
      item.value = Math.round(item.value / 10000)
      return item
    })
  },
  watch: {

  },
  methods: {
    chinaTerimalGeoFormatter (terimalLists = []) {
      if (this.$refs['echartChina']) {
        // this.$refs['echartChina'].options.visualMap.show = false
        this.$refs['echartChina'].options.geo.label.normal.fontSize = '15'
        this.$refs['echartChina'].options.visualMap.max = '13000'
        this.$refs['echartChina'].options.geo.label.normal.formatter = (e) => {
          let itemName
          let itemVal = terimalLists.find(item => {
            itemName = item.province.replace(/['省','市'，'回族自治区','自治区','壮族','特别行政区','维吾尔自治区']/g, '')
            return itemName === e.name
          })
          if (itemVal) {
            return `${itemName}\n${parseInt((itemVal.allrevenue / 10000))}`
          }
          return e.name
        }
        this.$refs['echartChina'].options.geo.label.normal.color = '#fff'

        this.$refs['echartChina'].options.tooltip.formatter = (e) => {
          let data = e.data
          let context
          if (data) {
            let itemName
            let itemVal = terimalLists.find(item => {
              itemName = item.province.replace(/['省','市'，'回族自治区','自治区','壮族','特别行政区','维吾尔自治区']/g, '')
              return itemName === data.name
            })
            context = `
             <div>
                  <p>${data.name}</p>
                  <p><span>人口：</span>${this.numberSplitWithComma(data.value)}万</p>
                  <p><span>终端：</span>${this.numberSplitWithComma(Math.round(itemVal.allrevenue / 10000))}万</p>
             </div>
             `
          }
          return context
        }
        this.$refs['echartChina'].setChartInit()
      }
    }
  },
  activated () {
    const choiceDate = JSON.parse(sessionStorage.getItem('toggleDate'))
    this.$service.fetch({
      url: '/api/global/dashboard_v2',
      params: {
        month: choiceDate.time // '2021-01'
      }
    }).then(res => {
      // 终端分布
      this.terimalLists = res.media
      this.$nextTick(() => {
        this.chinaTerimalGeoFormatter(res.media.terminalMapList)
      })
    })
  }
}
</script>

<style scoped lang="stylus">
#ChinaMapTerimal
  height 100%
</style>
